function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.629 258.204c-33.31-93.165 23.674-220.459 120.7-252.01 16.991-5.71 55.93-10.698 73.881.522 26.58 16.614 10.15 71.602 33.863 132.156 25.956 66.128 99.64 74.179 90.805 136.895-6.51 46.211-40.29 66.347-72.011 77.008-95.971 32.36-215.495-5.797-247.238-94.571z",
  fill: "#9775C1"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M262.369 41.8c20.797-10.005 42.262 6.672 44.83 26.493 2.567 19.821-12.572 35.564-32.074 35.601-19.502.037-33.554-52.088-12.756-62.093z",
  fill: "#FFAFA4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M331.139 78.521l-9.612-2.136m9.143-15.936l-9.479 2.168m1.315-17.498l-7.555 5.818m10.191 42.104l-8.129-4.933",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgImgBgSlideshowFeatures2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 365,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMzIiBoZWlnaHQ9IjM2NSIgdmlld0JveD0iMCAwIDMzMyAzNjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjYyODU3IDI1OC4yMDRDLTIzLjY4MDUgMTY1LjAzOSAzMy4zMDMxIDM3Ljc0NTQgMTMwLjMyOSA2LjE5MzlDMTQ3LjMyIDAuNDg0MzI5IDE4Ni4yNTkgLTQuNTA0MDEgMjA0LjIxIDYuNzE2MTFDMjMwLjc5IDIzLjMzMDEgMjE0LjM2IDc4LjMxNzcgMjM4LjA3MyAxMzguODcyQzI2NC4wMjkgMjA1IDMzNy43MTMgMjEzLjA1MSAzMjguODc4IDI3NS43NjdDMzIyLjM2OCAzMjEuOTc4IDI4OC41ODggMzQyLjExNCAyNTYuODY3IDM1Mi43NzVDMTYwLjg5NiAzODUuMTM1IDQxLjM3MjMgMzQ2Ljk3OCA5LjYyODU3IDI1OC4yMDRaIiBmaWxsPSIjOTc3NUMxIi8+CjxwYXRoIGQ9Ik0yNjIuMzY5IDQxLjgwMDdDMjgzLjE2NiAzMS43OTUgMzA0LjYzMSA0OC40NzE2IDMwNy4xOTkgNjguMjkyOEMzMDkuNzY2IDg4LjExNCAyOTQuNjI3IDEwMy44NTcgMjc1LjEyNSAxMDMuODk0QzI1NS42MjMgMTAzLjkzMSAyNDEuNTcxIDUxLjgwNjQgMjYyLjM2OSA0MS44MDA3WiIgZmlsbD0iI0ZGQUZBNCIvPgo8cGF0aCBkPSJNMzMxLjEzOSA3OC41MjExTDMyMS41MjcgNzYuMzg0OU0zMzAuNjcgNjAuNDQ5TDMyMS4xOTEgNjIuNjE3Mk0zMjIuNTA2IDQ1LjExODlMMzE0Ljk1MSA1MC45MzY2TTMyNS4xNDIgOTMuMDQwOUwzMTcuMDEzIDg4LjEwNzgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgImgBgSlideshowFeatures2 as ReactComponent };